import MapEquipmentDetailController from './equipment-detail.controller';
import template from './equipment-detail.component.html';

export default function MapEquipmentDetailDirective() {
  return {
    restrict: 'E',
    template,
    scope: {
      asset: '=',
      panelOffScreen: '<'
    },
    controller: MapEquipmentDetailController,
    //not useing vm as when using ui-route it is conflicting with parent vm
    //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
    controllerAs: 'detailVm'
  };
}
